/* eslint camelcase: 0 */
import { MonitaroGatewayBase } from './base'
import { toDoctorProps } from './translator/doctor'
import { toQuery, toQueryProps } from './translator/query'
import { toAppointmentProps } from './translator/appointment'
import { EmptyResponsePropsFactory } from '@/entities/Response'
import { IQueryProps } from '@/entities/Query'
import { FetchDoctor, GetDoctor, GetDoctorAppointment } from '@/infrastructure/network/Monitaro/requests/doctor'

export default class Doctor extends MonitaroGatewayBase {
  async FetchDoctor(query?: IQueryProps) {
    const response = await this.apiClient.request(new FetchDoctor(toQuery(query)))
    return EmptyResponsePropsFactory({
      items: response.doctors.map((prop) => toDoctorProps(prop)),
      query: toQueryProps(response.query)
    })
  }

  async GetDoctor(id: string) {
    const { doctor } = await this.apiClient.request(new GetDoctor(id))
    return toDoctorProps(doctor)
  }

  async GetDoctorAppointment(doctor: string, date: string) {
    const { appointments } = await this.apiClient.request(new GetDoctorAppointment(doctor, date))
    return appointments.map(toAppointmentProps)
  }
}
